"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleToggleColHeader = void 0;
var lodash_1 = require("lodash");
var handleToggleColHeader = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = data.map(function (row) {
        var newRowData = (0, lodash_1.cloneDeep)(row);
        if (newRowData.cellData[0].isRowHeader) { //then remove
            delete newRowData.cellData[0].isRowHeader;
        }
        else {
            newRowData.cellData[0].isRowHeader = true;
        }
        return newRowData;
    });
    onChange &&
        onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleToggleColHeader = handleToggleColHeader;
